import type { CategorizationRule, KeywordMapping } from '../types';

export const RULES: CategorizationRule[] = [
  {
    category: "Subscriptions",
    keywords: [
      "netflix",
      "spotify",
      "hulu",
      "disney+",
      "disney",
      "apple.com/bill",
      "apple music",
      "amazon prime",
      "youtube premium",
      "google one",
      "game pass",
      "playstation",
      "nintendo online",
      "adobe",
      "dropbox",
      "icloud",
      "peacock",
      "1password",
      "openai",
      "google storage",
      "onepass",
      "hbo max",
      "max streaming",
      "max subscription",
      "paramount+",
      "paramount plus",
      "showtime",
      "starz",
      "hbo",
      "espn+",
      "espn plus",
      "twitch",
      "crunchyroll",
      "funimation",
      "discord nitro",
      "microsoft 365",
      "office 365",
      "zoom",
      "slack",
      "notion",
      "evernote",
      "lastpass",
      "dashlane",
    ],
  },
  {
    category: "Shopping",
    keywords: [
      "target",
      "walmart",
      "amazon",
      "amzn",
      "ebay",
      "kohls",
      "macys",
      "nordstrom",
      "tjmaxx",
      "marshalls",
      "ross stores",
      "best buy",
      "bed bath",
      "etsy",
      "hobby lobby",
      "half price books",
      "dollar tree",
      "michaels",
      "joann",
      "five below",
      "andersons books",
      "barnes noble",
      "homegoods",
      "cdkeys",
      "party city",
      "tiktok shop",
      "temu",
      "kindle",
      "wayfair",
      "overstock",
      "newegg",
    ],
  },
];

export const DISPLAY_NAMES: KeywordMapping[] = [
  // Subscriptions
  { keyword: "netflix", displayName: "Netflix" },
  { keyword: "spotify", displayName: "Spotify" },
  { keyword: "hulu", displayName: "Hulu" },
  { keyword: "disney+", displayName: "Disney+" },
  { keyword: "disney", displayName: "Disney+" },
  { keyword: "apple.com/bill", displayName: "Apple" },
  { keyword: "apple music", displayName: "Apple Music" },
  { keyword: "amazon prime", displayName: "Amazon Prime" },
  { keyword: "youtube premium", displayName: "YouTube Premium" },
  { keyword: "peacock", displayName: "Peacock" },
  { keyword: "1password", displayName: "1Password" },
  { keyword: "openai", displayName: "OpenAI" },
  { keyword: "hbo max", displayName: "Max" },
  { keyword: "max streaming", displayName: "Max" },
  { keyword: "max subscription", displayName: "Max" },
  { keyword: "paramount+", displayName: "Paramount+" },
  { keyword: "paramount plus", displayName: "Paramount+" },
  { keyword: "hbo", displayName: "HBO" },
  { keyword: "showtime", displayName: "Showtime" },
  { keyword: "espn+", displayName: "ESPN+" },
  { keyword: "espn plus", displayName: "ESPN+" },

  // Retail
  { keyword: "amazon", displayName: "Amazon" },
  { keyword: "amzn", displayName: "Amazon" },
  { keyword: "best buy", displayName: "Best Buy" },
  { keyword: "target", displayName: "Target" },
  { keyword: "walmart", displayName: "Walmart" },
  { keyword: "kohls", displayName: "Kohl's" },
  { keyword: "macys", displayName: "Macy's" },
  { keyword: "nordstrom", displayName: "Nordstrom" },
  { keyword: "tjmaxx", displayName: "TJ Maxx" },
  { keyword: "marshalls", displayName: "Marshalls" },
  { keyword: "ross stores", displayName: "Ross" },
  { keyword: "homegoods", displayName: "HomeGoods" },
  { keyword: "hobby lobby", displayName: "Hobby Lobby" },
  { keyword: "michaels", displayName: "Michaels" },
  { keyword: "joann", displayName: "Joann" },
  { keyword: "barnes noble", displayName: "Barnes & Noble" },
  { keyword: "five below", displayName: "Five Below" },
  { keyword: "wayfair", displayName: "Wayfair" },
];
